import {
	SET_MEDIA_HIDDEN,
	SET_MEDIA_OPENED,
	SET_MOBILE,
	SET_ROUTE,
	SET_SEARCH_HIDDEN,
	SET_SEARCH_OPENED,
	SET_SIDEBAR_HIDDEN,
	SET_SIDEBAR_OPENED,
	SET_WINDOW_WIDTH
} from "./constants";
import settings from "../../data/settings.json";

const { buildings } = settings;
// import { canvas, filters, pois, settings } from "../index";

export const setRoute = routeName => dispatch =>
	new Promise(resolve => {
		const building =
			routeName.split("/").length > 1 ? routeName.split("/")[1] : "";
		const checkBuilding = buildings.indexOf(building);
		dispatch({
			type: SET_ROUTE,
			routeName,
			building: checkBuilding > -1 ? building : buildings[0]
		});
		resolve(routeName);
	});

export const windowSizeChange = ({ state }) => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_WINDOW_WIDTH,
			width: window.innerWidth
		});
		resolve(state);
	});

export const setSearchHidden = hidden => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_SEARCH_HIDDEN,
			hidden
		});
		resolve(hidden);
	});

export const setSidebarHidden = hidden => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_SIDEBAR_HIDDEN,
			hidden
		});
		resolve(hidden);
	});

export const setMediaHidden = hidden => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_MEDIA_HIDDEN,
			hidden
		});
		resolve(hidden);
	});

export const openSearch = () => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_SEARCH_OPENED
		});
		resolve();
	});

export const openMedia = () => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_MEDIA_OPENED
		});
		resolve();
	});

export const openSidebar = () => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_SIDEBAR_OPENED
		});
		resolve();
	});

export const setMobile = isMobile => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_MOBILE,
			isMobile
		});
		resolve();
	});
